import styled from '@emotion/styled/macro'
import colors from '@sportninja/common/constants/appColors'

import { font, zIndex } from '../css'
import { media } from '../Responsive'

export const DEFAULT_COL_WIDTH = 58
export const DEFAULT_COL_WIDTH_MOBILE = 52
export const DEFAULT_COL_1_WIDTH = 200
export const DEFAULT_COL_1_WIDTH_MOBILE = 120
export const DEFAULT_ROW_HEIGHT = 56

const StatisticsWrapper = styled.div`
  /* Overwrite the padding from Container */
  padding-bottom: 40px;

  .wrap {
    padding: 0 8px;
  }

  .header-group {
    .header-inner {
      display: flex;

      ${media.mobile} {
        overflow: hidden;
      }
    }

    .header {
      flex: 1;
      display: flex !important;
      align-items: center;
      justify-content: center;
      height: ${DEFAULT_ROW_HEIGHT}px;
      min-width: 54px;
      background-color: #242830;
      font-weight: 700;
      text-align: center;

      position: relative;

      &:hover {
        .header-tooltip {
          opacity: 1;
        }
      }
    }

    .header-tooltip {
      z-index: ${zIndex.base};
      position: absolute;
      top: 38px;
      right: 0;
      opacity: 0;
      min-width: max-content;
      transition: opacity 0.2s ease-in-out;
      background-color: ${colors.HEADER};
      border: 1px solid ${colors.ATTENDANCE_GRAY};
      border-radius: 3px;
      padding: 4px;
      font-size: 13px;
      text-align: right;
    }
  }

  .table {
    max-width: 100%;
    position: relative;
    overscroll-behavior: contain;
  }

  .body {
    display: flex;
    overflow: auto;
    flex-direction: column;

    &::after {
      background: linear-gradient(
        to left,
        rgba(0, 0, 0, 0.5),
        transparent 55%,
        transparent
      );
      bottom: 0;
      content: '';
      position: absolute;
      right: 0;
      top: 0;
      width: 42px;
      z-index: 1;
      pointer-events: none;

      transition: opacity 250ms;
      opacity: 0;
    }

    &::before {
      background: linear-gradient(
        to right,
        rgba(0, 0, 0, 0.5),
        transparent 55%,
        transparent
      );
      bottom: 0;
      content: '';
      position: absolute;
      left: ${DEFAULT_COL_1_WIDTH}px;
      top: 0;
      width: 42px;
      z-index: 1;
      pointer-events: none;

      transition: opacity 250ms;
      opacity: 0;
    }

    &.has-season-column::before {
      left: ${DEFAULT_COL_1_WIDTH}px;
    }

    &.show-right-fade::after,
    &.show-left-fade::before {
      opacity: 1;
    }
  }

  .cell {
    display: flex;
    align-items: center;
    justify-content: center;
    height: ${DEFAULT_ROW_HEIGHT}px;
    flex: 1;
    min-width: 54px;

    &.is-row-1 {
      padding-top: 4px;
    }

    &.is-sorted {
      color: ${colors.DEFAULT_FLAIR};

      a {
        color: ${colors.DEFAULT_FLAIR};
      }
    }
  }

  .is-name-col {
    text-align: left;
    justify-content: flex-start;
    position: sticky;
    left: 0;
    padding: 0 8px;

    &.header {
      min-width: ${DEFAULT_COL_1_WIDTH}px;
      text-transform: uppercase;
      justify-content: flex-start;

      &:not(:first-of-type) {
        text-align: center;
      }
    }
    z-index: 2;
  }

  .is-team-name,
  .header.is-team-name {
    justify-content: flex-start;
    padding-left: 12px;
  }

  .is-grouped {
    position: relative;
    align-items: center;
    height: ${DEFAULT_ROW_HEIGHT}px;
    padding-left: 16px;
    ${font.title};
    font-weight: bold;
    font-size: 20px;
    cursor: pointer;
  }

  .grouped-cell {
    position: sticky;
    left: 16px;
  }

  .row {
    width: 100%;
  }

  .row:nth-of-type(odd) .cell {
    background-color: #1f2229;
  }

  .row:nth-of-type(even) .cell {
    background-color: #292e35;
  }

  &.mobile {
    max-width: 100vw;
    margin-left: 0;

    .header-group {
      top: 109px;
    }

    .header {
      background-color: #282e38;

      &.is-name-col {
        min-width: 120px;
      }
    }

    .body::before {
      left: ${DEFAULT_COL_1_WIDTH_MOBILE}px;
    }

    .row:nth-of-type(even) .cell {
      background-color: #323944;
    }

    .row:nth-of-type(odd) .cell {
      background-color: #282e38;
    }

    .is-grouped {
      padding-left: 8px;
    }

    .grouped-cell {
      left: 8px;
    }
  }

  &.mobile.is-game .header-group {
    top: 165px;
  }
`

export default StatisticsWrapper
